import React from 'react';
import { useDispatch } from 'react-redux';

import { makeStyles, Typography, Theme, Tooltip, IconButton } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';

import { MAIN_MAP } from '../../../redux/map/Constants';
import { setShapeFeatureProperty } from '../../../redux/map/Actions';

interface Styles {
    root2: React.CSSProperties;
    line: React.CSSProperties;
    label: React.CSSProperties;
    icon: React.CSSProperties;
    toolTip: React.CSSProperties;
}

const useStyles = makeStyles<Theme, object, keyof Styles>(() => styles() as Styles);

function Line({
    featureId,
    strokeColour = '#A9FE95',
    strokeStyle = 'dashed',
    name,
    needed = true,
    locked
}: any): React.ReactElement {
    const classes = useStyles();
    const dispatch = useDispatch();
    const isLocked = Boolean(locked);

    function dispatchSetShapeFeatureProperty(userProperty: string, userPropertyValue: any): void {
        dispatch(setShapeFeatureProperty(featureId, userProperty, userPropertyValue, MAIN_MAP));
    }
    function handleShapeLocking(): any {
        dispatchSetShapeFeatureProperty('isLocked', !isLocked);
    }

    return (
        <div className={classes.root2}>
            <div
                className={classes.line}
                style={{
                    width: '20px',
                    height: 1,
                    borderTop: `2px ${strokeStyle as string} ${strokeColour as string}`,
                    borderRadius: 0,
                    marginBottom: 0,
                    marginTop: 0
                }}
            />
            <Typography classes={{ root: classes.label }} variant="caption" color="textPrimary">
                {needed ? name || 'Drawn shape' : ''}
            </Typography>
            {locked ? (
                <Tooltip
                    arrow
                    placement="bottom"
                    title="The shape is locked and unmovable on the map. To unlock the shape click the lock."
                    leaveDelay={300}>
                    <IconButton classes={{ root: classes.toolTip }} onClick={handleShapeLocking}>
                        <LockIcon fontSize="small" classes={{ root: classes.icon }} />
                    </IconButton>
                </Tooltip>
            ) : (
                ''
            )}
        </div>
    );
}

const styles = (): any => ({
    root2: {
        display: 'flex',
        alignItems: 'center'
    },
    label: {
        marginLeft: 5,
        fontSize: 10
    },
    line: {
        minWidth: 20,
        flexShrink: 0
    },
    icon: {
        color: '#FFFFFF',
        height: '10px'
    },
    toolTip: {
        padding: 3
    }
});

export default Line;
